import { BetaFeaturesAuthData } from './types'

export const canManageBetaFeatures = ({ isSelectraAdmin, extraRoutes }: BetaFeaturesAuthData = {}): boolean =>
  isSelectraAdmin === true && Boolean(extraRoutes?.betaFeatures?.list)
